import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import WorkType from "@/models/Shared/WorkType";

export default class UpdateWorkerPositionRequest extends BaseUpdateRequest{
    status: number;
    payRate: number;
    workTypes: WorkType[];
}